'use strict';

var React = require('react');
var Reflux = require('reflux');
var Router = require('react-router');
var Navigation = Router.Navigation;

/* Components */
var TextField = require('components/ui/text-field');
var Button = require('components/ui/button');

/* Actions */
var AuthenticationActions = require('actions/authentication');

/* Stores */
var LanguageStore = require('stores/language');
var AuthenticationStore = require('stores/authentication');

var Login = React.createClass({
  displayName: 'Login',

  mixins: [Reflux.connect(AuthenticationStore, 'authentication'), Navigation],

  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var component = this;

    if (component.state.authentication.status === 'authenticated') {
      var attemptedTransition = AuthenticationStore.attemptedTransition;

      if (attemptedTransition) {
        AuthenticationStore.attemptedTransition = null;
        attemptedTransition.retry();
      } else {
        component.replaceWith('/');
      }
    }
  },

  render: function render() {
    var component = this;
    var state = component.state;
    var _onSubmit = component._onSubmit;
    var status = state.authentication.status;

    if (status === 'loading') {
      return null;
    }

    /* Validation */
    var disabled = status === 'authenticating';
    var invalid = status === 'failed';

    /* Texts */
    var titleText = LanguageStore.translate('login_title');

    return React.createElement(
      'div',
      { className: 'login-component-wrapper' },
      React.createElement(
        'form',
        { className: 'login-component', id: 'loginForm', onSubmit: _onSubmit },
        React.createElement(TextField, { type: 'email', ref: 'emailField', translationKey: 'login_email', disabled: disabled, invalid: invalid }),
        React.createElement(TextField, { type: 'password', ref: 'passwordField', translationKey: 'login_password', disabled: disabled, invalid: invalid }),
        React.createElement(Button, { type: 'submit', translationKey: 'login_submit', disabled: disabled })
      )
    );
  },

  _onSubmit: function _onSubmit(evt) {
    evt.preventDefault();

    var component = this;
    var refs = component.refs;
    var emailField = refs.emailField;
    var passwordField = refs.passwordField;

    var email = emailField.value;
    var password = passwordField.value;

    AuthenticationActions.submit(email, password);
  }

});

module.exports = Login;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/login.js
 **/